import { render } from "./AnnotationsTab.vue?vue&type=template&id=43b3fd12&scoped=true"
import script from "./AnnotationsTab.vue?vue&type=script&lang=js"
export * from "./AnnotationsTab.vue?vue&type=script&lang=js"

import "./AnnotationsTab.vue?vue&type=style&index=0&id=43b3fd12&lang=scss&scoped=true"

import exportComponent from "/tmp/tmp.J0U5ZeTglF/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b3fd12"]])

export default __exports__